import React from "react";
import { LegalLayout, Section, Bullets } from "@/components/legal/LegalLayout";
import { BILLING_EMAIL } from "@/constants/legal";

export default function RefundPolicy() {
  return (
    <LegalLayout
      slug="refund-policy"
      title="Refund Policy"
      subtitle="This Refund Policy explains when refunds are available for HostGuard subscriptions. It should be read together with our Subscription & Billing Policy and Terms of Service."
    >
      <Section title="1. Monthly subscriptions">
        <p>HostGuard paid plans are monthly subscriptions billed in advance. Because you receive immediate access to paid features for the billing period, subscription fees are generally non-refundable except as set out below or as required by the Australian Consumer Law.</p>
      </Section>

      <Section title="2. No partial-month refunds">
        <p>We do not provide partial or pro-rata refunds for unused time within a billing period. When you cancel, you keep paid access until the end of the current period, after which billing stops and your account reverts to the Free plan.</p>
      </Section>

      <Section title="3. When we will consider a refund">
        <p>We will consider a refund on a case-by-case basis in limited circumstances, including:</p>
        <Bullets items={[
          "A verified technical failure that prevented you from using the paid features for a material part of the billing period, and which we were unable to resolve.",
          "An accidental duplicate charge for the same billing period.",
          "Where a refund is required under the Australian Consumer Law.",
        ]} />
      </Section>

      <Section title="4. How refunds are reviewed">
        <p>Refund requests are reviewed individually on their merits. We may ask for relevant detail (such as the date, charge and nature of the issue) to assess your request. Approved refunds are returned to your original payment method via Stripe and may take several business days to appear.</p>
      </Section>

      <Section title="5. Your consumer rights">
        <p>Nothing in this policy limits rights you may have under the Australian Consumer Law that cannot lawfully be excluded, including rights to a remedy if a service is not provided with due care and skill or is not fit for purpose.</p>
      </Section>

      <Section title="6. How to request a refund">
        <p>To request a refund, contact <a href={`mailto:${BILLING_EMAIL}`} className="font-medium text-primary hover:underline">{BILLING_EMAIL}</a> or use our <a href="/contact" className="font-medium text-primary hover:underline">Contact page</a> within 30 days of the charge, including your account email and details of the issue.</p>
      </Section>
    </LegalLayout>
  );
}
